import React, { useEffect } from 'react';
import { X, Edit2, Truck, User, MapPin, Wrench } from 'lucide-react';
import './VehicleDetailsPanel.css';

export default function VehicleDetailsPanel({ isOpen, onClose, vehicleData, onEdit }) {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        onClose();
      }
    };
    if (isOpen) {
      window.addEventListener('keydown', handleEsc);
    }
    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [isOpen, onClose]);

  if (!isOpen || !vehicleData) return null;

  const getStatusClass = (status) => {
    switch (status?.toLowerCase()) {
      case 'active':
        return 'status-active';
      case 'maintenance':
        return 'status-maintenance';
      case 'idle':
        return 'status-idle';
      default:
        return 'status-idle';
    }
  };

  return (
    <>
      <div className="panel-backdrop" onClick={onClose}></div>
      <div className="vehicle-details-panel">
        <div className="panel-header">
          <h2>Vehicle Details</h2>
          <div className="panel-header-actions">
            <button className="panel-edit-btn" onClick={() => onEdit && onEdit(vehicleData)} title="Edit Vehicle">
              <Edit2 size={18} />
              <span>Edit</span>
            </button>
            <button className="panel-close-btn" onClick={onClose}>
              <X size={20} />
            </button>
          </div>
        </div>

        <div className="panel-content">
          <div className="panel-vehicle-profile">
            <div className="vehicle-icon-large">
              <Truck size={32} />
            </div>
            <div className="vehicle-title-info">
              <h3>{vehicleData.id}</h3>
              <p className="vehicle-type-text">{vehicleData.type}</p>
              <span className={`status-badge ${getStatusClass(vehicleData.status)}`} style={{marginTop: '8px', display: 'inline-block'}}>
                {vehicleData.status?.toUpperCase() || 'UNKNOWN'}
              </span>
            </div>
          </div>

          <div className="panel-section">
            <h3 className="panel-section-title">Assignment</h3>
            <div className="panel-icon-row">
              <User size={16} className="panel-icon" />
              <div>
                <p className="panel-label" style={{marginBottom: 0}}>Assigned Courier</p>
                <p className="panel-value-bold">{vehicleData.assignedCourier?.name || vehicleData.courier || 'Unassigned'}</p>
              </div>
            </div>
          </div>

          <div className="panel-section">
            <h3 className="panel-section-title">Current Status</h3>
            <div className="panel-icon-row">
              <MapPin size={16} className="panel-icon" />
              <div>
                <p className="panel-label" style={{marginBottom: 0}}>Current Route / Location</p>
                <p className="panel-value-bold">{vehicleData.currentRoute || 'N/A'}</p>
              </div>
            </div>
          </div>


        </div>
      </div>
    </>
  );
}
